<template>
  <div :class="mode" v-if="threads.length > 0">
    <button class="toggle-button" @click="toggleMode" :data-new="unreadThreadsCount"><i class="fas fa-comments"></i>Messagerie</button>
    <div class="chat__wrapper">
      <i class="close_chat fas fa-times" @click="toggleMode"></i>
      <ul class="chat__list">
        <li v-for="thread in threads" :class="{chat__users: true, selected: thread.id === currentThreadId}" @click="e => selectThread(thread.id)">
          <div :class="{chat__img: true, 'new-message': thread.is_unread}">
            <i class="fas fa-users" v-if="thread.user === 'family'" />
            <avatar v-else :recipe="thread.user.avatar" />
          </div>
          <div class="chat__name" v-if="thread.user === 'family'">Famille</div>
          <div class="chat__name" v-else>{{ thread.user.first_name }} {{ thread.user.last_name }}</div>
        </li>
      </ul>
      <div class="chat__display">
        <div class="chat__display__message" v-if="currentThread" ref="display_thread">
          <div :class="{user: true, myself: message.user.id === me.id}" v-for="message in currentThread.messages">
            <div class="user__image">
              <avatar :recipe="message.user.avatar" />
            </div>
            <div class="user__content">
              <h5 class="username">{{ message.user.first_name }} {{ message.user.last_name }}</h5>
              <p>{{ message.body }}</p>
            </div>
            <p class="date">{{ formatDateTime(message.created_at) }}</p>
          </div>
        </div>
        <div class="chat__type__message" v-if="currentThread">
          <form @submit.prevent="sendMessage">
            <input type="text" placeholder="Ecrivez votre message ici" v-model="messageInput" :disabled="sendingStatus !== 'idle'" :class="sendingStatus">
            <button type="submit" class="button btnPush ">Envoyer</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import { formatDateTime } from '@/functions'
  import Avatar from '@/components/Avatar'

  export default {
    data: () => {
      return {
        img: 'https://placekitten.com/420/320?image=',
        name: 'https://uinames.com/api/?maxlen=25',
        currentThreadId: null,
        messageInput: '',
        sendingStatus: 'idle', // 'sending' / 'error'
        mode: 'closed',
        refreshTimer: null,
        formatDateTime
      }
    },
    components: { Avatar },
    methods: {
      ...mapActions(['addMessageToThread', 'markThreadAsRead', 'refreshThreadMessages', 'refreshMessenger']),
      async selectThread(threadId) {
        this.currentThreadId = threadId

        let currentThread = this.threads.find(thread => thread.id === this.currentThreadId)
        if (currentThread && currentThread.is_unread) {
          // TODO mettre un loading visuel
          await this.refreshThreadMessages({ threadId })
          // TODO enlever un loading visuel
          await this.markThreadAsRead({ threadId })
        }

        setTimeout(() => this.$refs.display_thread.scrollTop = this.$refs.display_thread.offsetHeight * 10, 1)
      },
      randomNumber() {
        return Math.floor(Math.random() * (12 - 1 + 1)) + 1;
      },
      async sendMessage() {
        this.sendingStatus = 'sending'
        if(!this.currentThreadId) {
          return
        }
        try {
          await this.addMessageToThread({ threadId: this.currentThread.id, message: this.messageInput })
          this.sendingStatus = 'idle'
          this.messageInput = ''
        }
        catch(error) {
          this.sendingStatus = 'error'
        }
        setTimeout(() => this.$refs.display_thread.scrollTop = this.$refs.display_thread.offsetHeight * 10, 1)
      },
      toggleMode() {
        if (this.mode === 'closed') {
          this.mode = 'small'
        } else if (this.mode === 'small') {
        //  this.mode = 'big'
        //} else if (this.mode === 'big') {
          this.mode = 'closed'
        }
      }
    },
    computed: {
      ...mapState(['threads', 'me']),
      currentThread() {
        if(!this.currentThreadId) {
          return null
        } else {
          return this.threads.find(thread => thread.id === this.currentThreadId)
        }
      },
      unreadThreadsCount() {
        return this.threads.filter(i => i.is_unread).length
      }
    },
    watch: {
      async unreadThreadsCount() {
        if (this.mode === 'closed') {
          return
        }

        let threadId = this.currentThreadId
        let currentThread = this.threads.find(thread => thread.id === threadId)
        if (currentThread && currentThread.is_unread) {
          await this.refreshThreadMessages({ threadId })
          await this.markThreadAsRead({ threadId })
          setTimeout(() => this.$refs.display_thread.scrollTop = this.$refs.display_thread.offsetHeight * 10, 1)
        }
      }
    },
    mounted() {
      this.refreshTimer = setInterval(() => this.refreshMessenger(), 10000);
    },
    beforeDestroy() {
      clearInterval(this.refreshTimer)
    }
  }
</script>

<style scoped>
form {
  width: 100%;
  display: flex;
}
.chat__list li {
  box-sizing: content-box;
}
.toggle-button {
  cursor: pointer;
  position: fixed;
  bottom: 0;
  right: 100px;
  width: 200px;
  border: 3px solid #281a7e;
  border-right: 10px solid #281a7e;
  border-bottom: 0;
  border-left: 0;
  padding: 15px;
  z-index: 1000;
  background: #086fab;
  border-radius: 20px 20px 0 0;
  color: white;
  transition: all 0.2s ease 0s;
}
.toggle-button:hover {
  padding: 15px 15px 30px;
}

.toggle-button .fas {
  margin: 0 15px 0 0;
}

.close_chat {
  position: absolute;
  z-index: 100;
  display: block;
  top: -10px;
  right: -10px;
  font-size: 30px;
  border-radius: 100px;
  height: 40px;
  padding: 12px;
  width: 40px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  color: white;
  background: #de2128;
  -webkit-box-shadow: 0px 8px 0px 0px #7f0004;
  box-shadow: 0px 8px 0px 0px #7f0004;
}
.close_chat:hover { top: -2px; box-shadow: 0px 0px 0px 0px #7f0004; }


.toggle-button:not([data-new="0"])::after {
  display: block;
  content: attr(data-new);
  color: #413492;
  position: absolute;
  top: -11px;
  left: -5px;
  background: #fff;
  padding: 8px;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  font-weight: bold;
  border: 2px solid #413492;
}
.chat__wrapper {
  display: -webkit-flex;
  display: flex;
  width: 80%;
  height: 80%;
  background-color: #fff;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  -moz-box-shadow: 0 25px 70px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 25px 70px rgba(0, 0, 0, 0.5);
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.5);
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 1000;
}
.small .chat__wrapper {
  max-width: 550px;
  max-height: 700px;
}
.closed .chat__wrapper {
  display: none;
}
.chat__wrapper .chat__list {
  -webkit-flex: 1 0 280px;
  flex: 1 0 280px;
  max-width: 280px;
  margin: 0;
  padding: 0;
  list-style: none;
  overflow-y: auto;
  background-color: #0768a0;
  transition: all 0.5s;
  overflow-x: hidden;
  border-radius: 10px 0 0 10px;
}
.chat__wrapper .chat__list::-webkit-scrollbar-track {
  background-color: transparent;
}
.chat__wrapper .chat__list::-webkit-scrollbar {
  width: 5px;
}
.chat__wrapper .chat__list::-webkit-scrollbar-thumb {
  background-color: #666666;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -moz-border-radius: rem(4px);
  -webkit-border-radius: rem(4px);
  border-radius: rem(4px);
}
.chat__wrapper .chat__list:not(:hover) {
  max-width: 70px;
}
.chat__wrapper .chat__list li {
  -webkit-align-items: center;
  align-items: center;
  text-align: left;
  padding: 10px 15px;
  border-bottom: 1px solid #0a2551;
  color: #fff;
  letter-spacing: 0.5px;
  height: 45px;
  width: 240px;
  line-height: 45px;
  cursor: pointer;
}
.chat__wrapper .chat__list li:hover,
.chat__wrapper .chat__list li.selected {
  background: #0a2551;
}
.chat__wrapper .chat__list li .chat__img {
  display: inline-block;
  width: 45px;
  height: 45px;
  margin-right: 10px;
  -moz-border-radius: 100%;
  -webkit-border-radius: 100%;
  border-radius: 100%;
  -moz-box-shadow: 0 2px 7px rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 2px 7px rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.5);
  position: relative;
}
.chat__wrapper .chat__list li .chat__img.new-message {
  background: white;
  box-shadow: 0 0 10px white;
}
.chat__wrapper .chat__list li .chat__img .avatar {
  transform: scale(0.3);
  transform-origin: 0 0;
  top: -9px;
  left: 0px;
}
.chat__wrapper .chat__list li .chat__name {
  display: inline-block;
  width: auto;
  overflow: hidden;
}
.chat__wrapper .chat__display {
  position: relative;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  width: 100%;

}
.chat__wrapper .chat__display .chat__display__message {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  text-align: left;
  padding-bottom: 30px;
}
.chat__wrapper .chat__display .chat__display__message::-webkit-scrollbar-track {
  background-color: transparent;
}
.chat__wrapper .chat__display .chat__display__message::-webkit-scrollbar {
  width: 5px;
}
.chat__wrapper .chat__display .chat__display__message::-webkit-scrollbar-thumb {
  background-color: #666666;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -moz-border-radius: rem(4px);
  -webkit-border-radius: rem(4px);
  border-radius: rem(4px);
}
.chat__wrapper .chat__display .chat__display__message .user {
  position: relative;
  padding: 20px 30px;
}
.chat__wrapper .chat__display .chat__display__message .user .date {
  margin: 10px 7px 0;
  font-size: 10px;
  float: right;
}
.chat__wrapper .chat__display .chat__display__message .user.myself .date {
  margin-top: 20px;
  float: left;
}
.chat__wrapper .chat__display .chat__display__message .user.myself .user__image {
  position: relative;
  float: right;
}
.chat__wrapper .chat__display .chat__display__message .user.myself .user__content {
  border-radius: 20px 0 20px 20px;
  top: 20px;
  border-color: #0768a0;
  background: #0768a0;
  color: white;
}
.chat__wrapper .chat__display .chat__display__message .user.myself .user__content p { color: white; }
.chat__wrapper .chat__display .chat__display__message .user.myself .user__image .avatar {
  top: 0;
  right: 0;
  left: 0;
}


.chat__wrapper .chat__display .chat__display__message .user:last-child:before {
  border-bottom: 0;
}
.chat__wrapper .chat__display .chat__display__message .user .user__image {
  float: left;
  width: 40px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.chat__wrapper .chat__display .chat__display__message .user .user__image .avatar {
  transform: scale(0.3);
  transform-origin: 0 0;
  top: 5px;
  left: 10px;
}
.chat__wrapper .chat__display .chat__display__message .user .user__content {
  overflow: hidden;
  border: 2px solid #ccc;
  border-radius: 0 20px 20px;
  padding: 15px;
  top: 10px;
  position: relative;
}
.chat__wrapper .chat__display .chat__display__message .user .user__content .username {
  font-weight: normal;
  margin: 0;
  letter-spacing: 0.3px;
  font-size: 13px;
}
.chat__wrapper .chat__display .chat__display__message .user p {
  margin-bottom: 0;
  color: gray;
  letter-spacing: 0.3px;
  line-height: 1.5;
}
.chat__wrapper .chat__display .chat__type__message {
  display: -webkit-flex;
  display: flex;
  padding: 10px;
  background-color: #eaeaea;
}
.chat__wrapper .chat__display .chat__type__message input {
  width: 80%;
  border: 0;
  padding: 9px 15px;
  border-radius: 10px;
  height: 55px;
  top: 8px;
  position: relative;
  margin-right: 15px;
}


.vb > .vb-dragger {
  z-index: 5;
  width: 12px;
  right: 0;
}

.vb > .vb-dragger > .vb-dragger-styler {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0, 0, 0, 0);
  transform: rotate3d(0, 0, 0, 0);
  -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out, height 100ms ease-out;
  transition: background-color 100ms ease-out, margin 100ms ease-out, height 100ms ease-out;
  background-color: rgba(48, 121, 244, 0.1);
  margin: 5px 5px 5px 0;
  border-radius: 20px;
  height: calc(100% - 10px);
  display: block;
}

.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.3);
}

.vb > .vb-dragger:hover > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.5);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.5);
  margin: 0px;
  height: 100%;
}

.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgba(48, 121, 244, 0.5);
}

@media (max-width: 640px) {

  .toggle-button { left: 10px; right: inherit; width: 155px;}

}

@media (max-width: 400px) {

  .chat__wrapper {width: 90%; overflow: hidden;}
  .chat__wrapper .chat__display .chat__display__message .user .user__image .avatar { transform: scale(0.2); }
  .chat__wrapper .chat__display .chat__display__message .user .user__image {
    width: 5px;
    z-index: 10;
    position: relative;
    top: -15px;
    left: -15px;
    }
  .close_chat {    top: 0; right: 0;}
  .chat__wrapper .chat__display .chat__display__message .user .user__content .username { display: none; }
  .chat__wrapper .chat__display .chat__display__message .user .user__content {    padding: 10px;  font-size: 14px; }
  .chat__wrapper .chat__display .chat__display__message .user { padding: 20px 10px; }
  .button {    padding: 15px 10px; font-size: 14px; }
  .chat__wrapper .chat__list:not(:hover) { z-index: 0; }
  .chat__wrapper .chat__list {       z-index: 1; flex: 1 0 220px;  max-width: 220px; }
  .chat__wrapper .chat__display .chat__display__message {padding-top: 46px;}
  .chat__wrapper .chat__display .chat__type__message {
    left: -70px;
    position: relative;
    width: calc(100% + 70px);
    }

}
.chat__img {
  text-align: center;
  float: left;
}
.chat__img i {
  font-size: 20px;
}
.chat__img.new-message i {
  color: #0768a0;
}
</style>
